<template>
  <div class="video_wrap">
    <IframeVideo :url="videoURL" />

    <img v-if="demoImg" :src="demoImg" alt="">

    <div class="bottom">
      <div class="position">
        <div class="title">
          <span :style="{ display:'flex' , alignItems:'center'  }">
            <span>坐标：</span>
            <span> <van-field :style="{padding: '6px', border: '1px solid #999',borderRadius: '4px',width: '60px' ,textAlign:'center', marginRight:'8px'}" v-model.number="indexX" type="number" maxlength="3" @blur="handleInputBlur('x')" /></span>&nbsp;&nbsp;
            <span> <van-field :style="{padding: '6px', border: '1px solid #999',borderRadius: '4px',width: '60px',textAlign:'center',}" v-model.number="indexY" type="number" maxlength="3" @blur="handleInputBlur('y')" /></span>
          </span>
          <span>
          </span>
          <van-button type="primary" @click="putPoint">预设位置</van-button>
        </div>
        <div class="title">
          <span :style="{ display:'flex' , alignItems:'center'  }">
            <span>深度：</span>
            <span> <van-field :style="{padding: '6px', border: '1px solid #999',borderRadius: '4px',width: '60px' ,textAlign:'center', marginRight:'8px'}" v-model.number="deepNum" type="number" maxlength="5" :disabled="true" /></span>&nbsp;&nbsp; cm
          </span>
        </div>
      </div>
      <div class="contrl">
        <div class="right">
          <img src="../../../assets/images/gx_mask.png" width="160px" height="220px" />
          <img id="shexiangtou" class="shexiangtou" src="../../../assets/images/gx_shexiangtou.png" width="32px" height="45px" :style="{...pointStyle}" />
        </div>
        <div class="left">
          <div class="circular circular1">
            <div class="circular circular2">
              <!-- 圆点 -->
              <div class="circular circular3"></div>
              <!-- 四个角 -->
              <a id="horn-top" class="horn horn-top" @mousedown="handleMousedown(0)" @mouseup="mouseup(0)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a id="horn-right" class="horn horn-right" @mousedown="handleMousedown(3)" @mouseup="mouseup(3)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a id="horn-bottom" class="horn horn-bottom" @mousedown="handleMousedown(1)" @mouseup="mouseup(1)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a id="horn-left" class="horn horn-left" @mousedown="handleMousedown(2)" @mouseup="mouseup(2)">
                <i class="iconfont icon-xiangxia" />
              </a>
            </div>
          </div>
        </div>

      </div>

      <div class="nums">
        <div :class="['item' ,  item.active && 'active' , !item.inUse && 'noUse' ]" v-for="(item,index) in preset" :key="item.label" @click="postPoint(item , index)">{{ item.label }}</div>
      </div>
    </div>

    <!-- 按钮组 -->
    <!-- <div class="btn-group">
      <van-button type="primary" @click="handleSetting(1)">设置</van-button>
      <van-button type="primary" @click="handleSetting(2)">局部数据</van-button>
      <van-button type="primary" @click="handleSetting(3)">详细数据</van-button>
      <van-button type="primary" :disabled="true">上传</van-button>
    </div> -->

    <van-popup v-model="pointShow" position="bottom" :style="{ padding: '18px 12px', boxSizing: 'border-box'}">
      <div class="point_popup">
        <div class="title">
          <span>预设点位</span>
          <span>
            <img src="./../../../assets/images/close.png" alt="" srcset="" @click="pointShow = false">
          </span>
        </div>
        <div class="content">
          <div class="nums">
            <div :class="['item', pointDialogActiveIndex === item.index && 'active' ]" v-for="(item,index) in preset" :key="item.label" @click="pointDialogClick(item , index)">{{ item.label }}</div>
          </div>
        </div>
        <div class="btns">
          <div class="btn save" @click="handleSave">保存</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import IframeVideo from "./iframe.vue";
import moment from "moment";
import ScreenShot from "@/utils/screenShot"

let timer = null

export default {
  components: {
    IframeVideo,
  },

  props: {
    videoInfo: {
      type: Object,
      default: () => ({})
    },
    hasDeviceChange: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    online: {
      default: false,
      type: Boolean
    }
  },

  watch: {
    online (v) {
    },

    async hasDeviceChange (v) {
      if (v) {
        const no = localStorage.getItem("no");
        this.no = no;
        this.initPoint([1, 2, 3, 4, 5, 6, 7, 8])
        await this.getThirdCamera()
        this.screenShot = new ScreenShot("iframe")
        await this.getPoint()
      }
    },

    refreshing (bl) {
      bl && this.onRefresh?.();
    },


    preset: {
      deep: true,
      handler (val) {
        console.log("presetpresetpreset:", val);
      }
    }
  },

  data () {
    return {
      dates: [],
      currentDateIndex: null,
      today: {},
      show: false,
      minDate: new Date("1970/1/1"),
      maxDate: new Date(),
      videoURL: "",
      channelNo: "",
      ysNo: "",
      isFirst: true,
      page: 1,
      pageSize: 20,
      oldList: [],
      totalPages: 1,
      list: [],
      finished: true,
      demoImg: "",
      no: localStorage.getItem("no"),
      screenShot: null,
      activePresetPoint: null,
      preset: [1, 2, 3, 4, 5, 6, 7, 8],
      pointShow: false,
      pointDialogActiveIndex: null,
      addLoading: false,
      isMouseUp: false,
      index: 0,
      indexX: 1,
      indexY: 1,
      hasVideo: false,
      pointStyle: {},
      deepNum: null
    };
  },

  created () {
    this.initPoint(this.preset)
  },

  async mounted () {
    await this.getThirdCamera()
    this.screenShot = new ScreenShot("iframe")
    await this.getPoint()

    let historyXY = localStorage.getItem(`root_type_22_${this.no}`)
    historyXY = historyXY ? JSON.parse(historyXY) : null

    console.log("historyXY:", historyXY);

    if (historyXY) {
      this.ctrlCamera22(historyXY.indexX, historyXY.indexY)
    } else {
      this.ctrlCamera22(1, 1)
    }

    const top = this.$el.querySelector('#horn-top');
    const bottom = this.$el.querySelector('#horn-bottom');
    const right = this.$el.querySelector('#horn-right');
    const left = this.$el.querySelector('#horn-left');

    [top, bottom, left, right].map((dom, index) => {
      dom.addEventListener("touchend", () => {
        clearInterval(timer)
        timer = null
        this.isMouseUp = true
      })

      dom.addEventListener("touchstart", () => {
        clearInterval(timer)
        this.isMouseUp = false
        this.handleCtrlClick(index)
        timer = setInterval(() => {
          if (this.isMouseUp || !timer) return clearInterval(timer)
          this.handleCtrlClick(index)
        }, 300);

      })
    })



  },

  methods: {
    initPoint (preset) {
      this.preset = preset.map(o => {
        return {
          label: `位置${o}`,
          name: o,
          index: o,
          inUse: false,
          active: false
        }
      })
    },

    // 获取预置点
    async getPoint () {
      await this.$api.rootMonitor_getPoint22({ no: this.no, }).then(res => {
        const { errcode, code } = res
        if (errcode === 0) {
          let preset = res.data?.length ? res.data : []
          const presetData = [...  this.preset]

          preset?.map((o, index) => {
            const findIndex = presetData.findIndex(io => io.name == o.indexName)
            if (findIndex > -1) {
              presetData[findIndex] = Object.assign(o, presetData[findIndex])
              presetData[findIndex].inUse = true
              presetData[findIndex].active = true
            }
          })
          this.preset = [...presetData]
          if (!this.hasVideo) {
            this.$toast.clear()
            this.$toast(`没有视频流地址`)
            return
          }
        }
      })
    },

    // 新增预置点
    async putPoint () {
      this.pointShow = true
    },

    // 保存
    async handleSave () {
      if (this.addLoading) return
      this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 0, })
      this.addLoading = true
      // 在已经有的点上保存则是修改 否则是 新增
      if (this.preset[this.pointDialogActiveIndex - 1].inUse) {
        this.$api.rootMonitor_updatePoint22({
          ...this.preset[this.pointDialogActiveIndex - 1],
          "indexX": this.indexX,
          "indexY": this.indexY,
          "ysNo": this.ysNo,
          "gatewayNo": this.no
        }).then(res => {
          if (res.errcode == 0) {
            console.log("更新成功");
            this.$toast.clear()
            this.addLoading = false
          }
        })
      } else {
        const status = await this.addPoint()
        if (status) {
          this.pointShow = false
          this.preset.map(o => {
            if (o.name == this.pointDialogActiveIndex) {
              o.active = true
            } else {
              o.active = false
            }
          })

        }
      }
      this.addLoading = false
      this.pointShow = false
      // 重新获取
      this.getPoint()
    },

    async addPoint () {
      // 要判断是新增还是修改
      return await this.$api.rootMonitor_putPoint22({
        ysNo: this.ysNo,
        channelNo: this.channelNo,
        "indexX": this.indexX,
        "indexY": this.indexY,
        "indexName": this.pointDialogActiveIndex,
        "gatewayNo": this.no
      }).then(async res => {
        await this.$toast.clear()
        const { errcode, index } = res
        if (errcode === 0) {
          return true
        } else {
          this.$toast(`保存预置点异常:${res.errmsg}`)
          return false
        }
      })
    },

    // 点击调用预置点
    async postPoint (data, index) {
      if (!data.inUse) { return this.$toast({ message: "该位置还未设置" }) }

      this.indexX = this.preset[index].indexX
      this.indexY = this.preset[index].indexY
      this.calculationDeep()

      this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 0, })
      await this.$api.rootMonitor_postPoint22({
        id: data.id,
      }).then(async res => {
        await this.$toast.clear()
        const { errcode, } = res
        if (errcode === 0) {
          if (index > -1) {
            this.preset.map(o => (o.active = false))
            setTimeout(() => {
              this.preset[index].active = true
            }, 0);

          }
        } else {
          this.$toast(`调用预置点异常:${res.errmsg}`)
        }
      })
    },

    pointDialogClick (data, index) {
      this.pointDialogActiveIndex = data.index
    },

    // 清除预置点
    async deletePoint (index) {
      await this.$api.rootMonitor_deletePoint22({
        "ysNo": this.ysNo,
        "channelNo": this.channelNo,
        index
      })
    },

    // 获取第三方摄像头
    async getThirdCamera (no = this.no) {
      this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });

      await this.$api.getThirdCamera({ gatewayNo: no })
        .then(res => {
          try {
            this.$toast.clear();
            let token = res.accessToken;

            if (!this.$isblank(res.videos)) {
              const videos = res.videos.map(item => {
                return {
                  ...item,
                  videoHdUrl: `https://open.ys7.com/ezopen/h5/iframe?url=${item.videoHdUrl || item.videoUrl}&accessToken=${token}`
                };
              });
              console.log("videos:", videos);
              this.hasVideo = true
              return this.renderVideo(videos?.[0] || {})
            } else {
              this.hasVideo = false
            }
          } catch (err) {
            console.error("err222:", err);
          }
        })
        .catch(err => {
          this.$refs.pageToast && (this.$refs.pageToast.type = 1);
          this.$toast.clear();
        });
    },

    async renderVideo (data) {
      try {
        let { videoHdUrl, channelNo, ysNo } = data
        this.videoURL = videoHdUrl;


        this.channelNo = channelNo;
        this.ysNo = ysNo;
        // 计算7天时间
        await this.sevenDays(new Date());
        this.currentDateIndex = this.dates.length - 1;
        this.today = this.formatCalendarDay(new Date(), 0);
      } catch (e) {
        console.error("e:", e);
      }
    },


    // 日历 确认
    onConfirm (date) {
      this.sevenDays(date);
      this.currentDateIndex = this.dates.length - 1;
      this.show = false;
    },

    // 切换日期
    handleClickDate (date, index) {
      this.currentDateIndex = index;
      // 请求视频和图片
      this.page = 1
    },

    mouseup (index) {
    },

    handleMousedown (index) {
      try {
      } catch (err) {
        console.error("err handleMousedown: ", err);
      }
    },

    // 视频控制
    async handleCtrlClick (index) {

      console.log("index:", index);

      let indexY = this.indexY, indexX = this.indexX
      if (index == 0) {
        // 上
        if (indexY - 1 <= 1) {
          indexY = 1
        } else {
          --indexY
        }
      } else if (index == 1) {
        // 下
        if (indexY + 1 == 100) {
          indexY = 100
        } else {
          ++indexY
        }
      } else if (index == 2) {
        // 左
        if (indexX - 1 <= 0) {
          indexX = 1
        } else {
          --indexX
        }
      } else {
        // 右
        if (indexX + 1 == 100) {
          indexX = 100
        } else {
          ++indexX
        }
      }

      this.ctrlCamera22(indexX, indexY)
    },


    // 调用摄像头切换位置  更具坐标
    async ctrlCamera22 (indexX, indexY) {
      this.indexX = indexX
      this.indexY = indexY
      this.calculationDeep()
      await this.$api.ctrlCamera22({ indexY, indexX, gatewayNo: this.no }).then((res) => {
        if (res.errcode === 0 || res.code == 200) {

        } else {
          this.$toast.fail(res.errmsg);
        }
      });
    },

    /**
     * @description 图片点击
     * @param {number} index list中的下标
     * @param {number} _index list中下标对象中的picList中的第几个
     */
    handleClickImg (index, _index) {
      const images = [];
      this.list[index].picList.map((item) => {
        item && images.push(item);
      });

      const { url, cdate, fileId, thumbUrl } = images[_index];

      this.$router.push({
        path: "/ai",
        query: {
          imgUrl: url,
          time: cdate,
          fileId,
        },
      });
    },

    sevenDays (date) {
      const nowDate = moment(date).startOf("day").format("YYYY-MM-DD"); // 当前时间点
      const dates = [];
      for (let i = 0; i < 6; i++) {
        dates.push(this.formatCalendarDay(nowDate, i + 1));
      }
      dates.reverse();
      dates.push(this.formatCalendarDay(nowDate, 0));

      console.log("dates:", dates);
      this.dates = dates;
    },

    // 参数时间戳
    getWeek (date) {
      let week = moment(date).day();
      switch (week) {
        case 1:
          return "一";
        case 2:
          return "二";
        case 3:
          return "三";
        case 4:
          return "四";
        case 5:
          return "五";
        case 6:
          return "六";
        case 0:
          return "日";
      }
    },

    formatCalendarDay (date, i) {
      const d = moment(date).subtract(i, "days").format("YYYY-MM-DD");
      return {
        date: d,
        week: this.getWeek(new Date(d.replaceAll("-", "/")).getTime()),
        num: d.split("-")[2],
      };
    },

    handleSetting (type) {
      const path = type == 1 ? "/videoPlayComSetting" : type == 2 ? '/videoPlayComPartData' : type == 3 ? '/videoPlayComDetail' : ''


      // 用来 在详细数据的页面 横屏时  重置 html，body  css 样式
      sessionStorage.setItem("_rootSetting_reload_", true)

      this.$router.push({
        path,
        query: {
          no: this.no,
          channelNo: this.channelNo,
          ysNo: this.ysNo
        }
      })
    },

    // X Y 失去焦点后则调用位置接口
    handleInputBlur (type) {
      if (type === "x") {
        this.indexX = Math.ceil(this.indexX)
      }

      if (type === "y") {
        this.indexY = Math.ceil(this.indexY)
      }

      if (isNaN(Number(this.indexX))) return
      if (isNaN(Number(this.indexY))) return

      if (this.indexX >= 100) this.indexX = 100
      if (this.indexY >= 100) this.indexY = 100
      if (this.indexX <= 1) this.indexX = 1
      if (this.indexY <= 1) this.indexY = 1

      this.ctrlCamera22(this.indexX, this.indexY)
      this.preset.map(o => { o.active = false })
    },

    calculationDeep () {
      const x = Number(this.indexX)
      const y = Number(this.indexY)

      const pointStyle = { ...this.pointStyle }
      const imgWidth = 160
      const imgHeight = 220
      const width = 100
      const height = 280

      const left = x * 1.6
      const top = y * 2.2

      pointStyle.left = `${left - 16}px`
      pointStyle.top = `${top - 28}px`

      this.pointStyle = { ...pointStyle }

      // 直接用Y%计算，例如当前垂直坐标为20，则深度为：20%*深度校验值
      this.deepNum = y * 0.28
      localStorage.setItem(`root_type_22_${this.no}`, JSON.stringify({ indexX: x, indexY: y }))
      console.log("pointStyle:", pointStyle);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../codeFunCommon.scss";
.video_wrap {
  background: #ffffff;
  .video {
    width: 100%;
    height: 220px;
    background: #999;
  }

  .body {
    padding: 12px 10px;
  }

  .contrl {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;
    padding: 12px;
    width: 100%;
    box-sizing: border-box;

    .left {
      position: relative;
      width: 50%;

      .circular {
        border-radius: 50%;
      }

      .circular1 {
        position: relative;
        width: 183.54px;
        height: 183.54px;
        background: rgba(241, 246, 251, 1);
        box-shadow: 2px 2px 8px 0px rgba(37, 87, 210, 0.15);
        text-align: center;
        margin-top: 10px;
      }

      .circular2 {
        position: absolute;
        left: 20px;
        top: 20px;
        width: 144px;
        height: 144px;
        background: linear-gradient(
            129.67deg,
            rgba(122, 127, 133, 0.4) 0%,
            rgba(255, 255, 255, 0.4) 100%
          ),
          linear-gradient(
            133.76deg,
            rgba(230, 231, 237, 1) 0%,
            rgba(247, 248, 250, 1) 100%
          );
        background-blend-mode: soft-light;
        box-shadow: inset 1px 1px 3px 0px rgba(235, 236, 240, 1),
          -2px -3px 8px 0px rgba(250, 250, 252, 1),
          1px 1px 5px 0px rgba(177, 181, 198, 1);
      }

      .circular3 {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 20.17px;
        height: 20.17px;
        background: rgba(37, 87, 210, 1);
      }

      .horn {
        position: absolute;
        user-select: none;

        i {
          color: rgba(206, 213, 220, 1);
          font-size: 22px;
        }
      }

      .horn-top {
        top: 0px;
        left: 60px;
        transform: rotateX(145deg);
      }

      .horn-right {
        top: 52px;
        right: 6px;
        transform: rotate(-90deg);
      }

      .horn-bottom {
        bottom: 0px;
        left: 63px;
      }

      .horn-left {
        top: 52px;
        left: 6px;
        transform: rotate(90deg);
      }
    }

    .right {
      position: relative;
      font-size: 14px;
      width: 160px;
      box-sizing: border-box;

      .box {
        text-align: center;
        width: auto !important;

        .label {
          margin-top: 8px;
        }

        i {
          color: rgba(46, 95, 215, 1);
        }
      }

      .r_top,
      .r_bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // width: 50%;
        box-sizing: border-box;

        .r_block {
          position: relative;
          display: inline-block;
          width: 44.13px;
          height: 44.13px;
          line-height: 44.13px;
          text-align: center;
          background: linear-gradient(
              129.67deg,
              rgba(122, 127, 133, 0.4) 0%,
              rgba(255, 255, 255, 0.4) 100%
            ),
            linear-gradient(
              133.76deg,
              rgba(230, 231, 237, 1) 0%,
              rgba(247, 248, 250, 1) 100%
            );
          background-blend-mode: soft-light;
          box-shadow: inset 1px 1px 3px 0px rgba(235, 236, 240, 1),
            -2px -3px 4px 0px rgba(250, 250, 252, 1),
            1px 1px 2px 0px rgba(177, 181, 198, 1);
          border-radius: 10px;
        }

        .miaozhun {
          position: absolute;
          top: 1px;
          left: 2px;
          right: 0;
          bottom: 0;
          margin: 0;
          font-size: 20px;
        }

        img {
          width: 60%;
          height: 60%;
        }
      }

      .r_top {
        margin-bottom: 20px;
      }

      .shexiangtou {
        position: absolute;
        left: -14px;
        top: -30px;
      }
    }
  }

  .calendar {
    display: flex;
    margin-bottom: 12px;
    font-size: 14px;

    .left {
      display: flex;

      .date-item {
        width: 39.78px;
        height: 40.66px;
        margin-right: 6px;
        background: rgba(210, 234, 253, 1);
        border-radius: 10px;
        text-align: center;
      }

      .active {
        background: rgba(37, 87, 210, 1);
        color: #ffffff;

        &::after {
          display: table;
          content: " ";
          width: 6px;
          height: 6px;
          background: rgba(37, 87, 210, 1);
          border-radius: 50%;
          margin-left: 16px;
          margin-top: 5px;
        }
      }
    }

    .right {
      position: relative;
      font-size: 18px;

      .icon-rili {
        font-size: 34px !important;
      }

      span {
        position: absolute;
        top: 12px;
        left: 7px;
      }
    }
  }

  .img-group {
    // padding: 0 10px 10px;

    .date {
      line-height: 40px;
      text-align: left;
    }

    .time {
      font-size: 12px;
      text-align: left;
    }

    .pic {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      width: 100%;

      .pic_item {
        width: 33%;
        // height: 100px;
        margin-bottom: 0.3rem;
        overflow: hidden;
        margin-right: 11px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.position {
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    box-sizing: border-box;
    padding: 0 10px;

    &:last-child {
      margin-bottom: 0;
    }

    span {
      font-size: 16px;
    }

    ::v-deep button {
      background: #1989fa;
      border-radius: 6px;
      height: 34px;
    }

    ::v-deep .van-field__control:disabled {
      -webkit-text-fill-color: #000 !important;
    }
  }
}

.nums {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;

  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 22%;
    color: #464646;
    margin-bottom: 10px;
    background: #f7f7f7;
    border: 0.95px solid #eceef2;
    border-radius: 4px;
    padding: 8px 0;
  }

  .active {
    background: #3a6ae0;
    color: #ffffff;
  }

  .noUse {
    color: #cdc4c4;
  }
}

.point_popup {
  .title {
    text-align: center;
    margin-bottom: 10px;
    font-size: 18px;
  }

  img {
    width: 14px;
    height: 14px;
    position: absolute;
    right: 18px;
    top: 23px;
  }

  .btns {
    text-align: center;
    margin-top: 40px;
    .save {
      width: 80%;
      height: 48px;
      line-height: 48px;
      background: #3a6ae0;
      border-radius: 29.5px;
      margin: auto;
      color: #ffffff;
    }
  }
}

.btn-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;

  button {
    width: 23%;
    height: 35px;
    line-height: 35px;
    padding-left: 0;
    padding-right: 0;
    background-color: #4778e7;
    border-color: #4778e7;
    border-radius: 6px;
  }
}

.data-page {
  background-color: #f7f7f7;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  .section {
    margin: 20px 0;
    padding: 10px 10px 12px 16px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 10.5px 31px #3981f60d;
    .space-x-13 {
      & > *:not(:first-child) {
        margin-left: 13px;
      }
      .image {
        width: 21px;
        height: 21px;
      }
      .text {
        color: #333333;
        font-size: 16px;
        font-family: PingFang SC;
        line-height: 14.5px;
      }
    }
    .text_2 {
      color: #808d9e;
      font-size: 12px;
      font-family: PingFang SC;
      line-height: 11px;
    }
    .section_2 {
      padding: 14px 8px;
      background-color: #f8f8f8;
      .text-wrapper {
        width: 58px;
      }
      .font_2 {
        font-size: 14px;
        font-family: PingFang SC;
        line-height: 13px;
        color: #505e82;
      }
    }
    .group {
      padding: 14px 16px 0;
      .text-wrapper_2 {
        width: 64.5px;
        border-right: solid 1px #e8e8e8;
      }
      .font_3 {
        font-size: 14px;
        font-family: PingFang SC;
        line-height: 10.5px;
        font-weight: 700;
        color: #333333;
      }
      .section_3 {
        background-color: #e8e8e8;
        width: 1px;
        height: 15.5px;
      }
      .text_6 {
        margin-right: 8px;
      }
    }
  }
  .space-y-10 {
    & > *:not(:first-child) {
      margin-top: 10px;
    }
  }
}
</style>

